import { render } from "./index.vue?vue&type=template&id=2fd48319&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2fd48319&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2fd48319"

export default script